// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessOrder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.824 11.461a.49.49 0 0 1-.48-.5V10.5c0-.276.215-.5.48-.5h4.778a.49.49 0 0 1 .48.5v.462a.49.49 0 0 1-.48.5zM17.314 11.5a.678.678 0 0 1-.504-.225.734.734 0 0 1-.216-.525c0-.2.072-.375.216-.525a.678.678 0 0 1 1.008 0c.144.15.216.325.216.525s-.072.375-.216.525a.678.678 0 0 1-.504.225zM9.824 8.477a.49.49 0 0 1-.48-.5v-.461c0-.276.215-.5.48-.5h4.778a.49.49 0 0 1 .48.5v.461a.49.49 0 0 1-.48.5zM17.314 8.488a.678.678 0 0 1-.504-.225.734.734 0 0 1-.216-.525c0-.2.072-.375.216-.525a.678.678 0 0 1 1.008 0c.144.15.216.325.216.525s-.072.375-.216.525a.678.678 0 0 1-.504.225zM9.348 13.508c0-.276.215-.5.48-.5h4.778a.49.49 0 0 1 .48.5v.461a.49.49 0 0 1-.48.5H9.828a.49.49 0 0 1-.48-.5zM16.599 13.758c0-.2.072-.375.216-.525a.678.678 0 0 1 1.008 0c.144.15.216.325.216.525s-.072.375-.216.525a.678.678 0 0 1-1.008 0 .734.734 0 0 1-.216-.525z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.313 22c-2.382 0-2.721-2.605-2.721-4.534 0-.277.215-.5.48-.5h1.9a.49.49 0 0 0 .48-.5V3S6.4 2.5 6.946 2.5c.494 0 .479.496.964.496s.954-.997 1.439-.997c.479 0 .967 1.002 1.444 1.002s.874-1.004 1.435-1.004c.613 0 .958 1.004 1.435 1.004.485 0 .967-1.005 1.444-1.005s.962 1.006 1.44 1.006c.481 0 .965-1.006 1.432-1.006.491 0 .972 1.006 1.45 1.006.477 0 .477-.5.956-.5.48 0 .48.5.48.5v16.164c0 .79-.265 1.46-.794 2.01a2.574 2.574 0 0 1-1.928.824zm11.68-2c.945 0 .958-.852.954-.99V5.504a.49.49 0 0 0-.48-.5H8.877a.49.49 0 0 0-.48.5L8.394 16.5c0 .276.215.5.48.5h7.205c.723 0 .942.38.942 1v.01c-.002.163-.027 1.99.972 1.99zm-10.08-1.407L5.49 18.59c0 1.541.631 1.91.823 1.91h9.506s-.698-.78-.698-1.91c-1.528.011-4.752.007-7.21.003z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessOrder;
